import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

/**
 * A loading placeholder. Every use must reserve the final height of what it
 * replaces: a chart skeleton that is shorter than its chart makes the page jump
 * when data lands, which reads as slower than it is.
 */
export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}
